export var HeaderV1Field;
(function (HeaderV1Field) {
    HeaderV1Field["ID"] = "Id";
    HeaderV1Field["VERSION"] = "Version";
    HeaderV1Field["SECTION_IDS"] = "SectionIds";
})(HeaderV1Field || (HeaderV1Field = {}));
export const HEADER_CORE_SEGMENT_FIELD_NAMES = [HeaderV1Field.ID, HeaderV1Field.VERSION, HeaderV1Field.SECTION_IDS];
